import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, Panel } from "@/components/admin/Field";
import { formatDate } from "@/lib/format";

export default function EditConta() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [changedAt, setChangedAt] = useState(user?.password_changed_at || null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) { toast.error("As palavras-passe não coincidem."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      setChangedAt(data.password_changed_at);
      setForm({ current: "", next: "", confirm: "" });
      toast.success("Palavra-passe alterada. A sessão continua ativa.");
    } catch (err) {
      toast.error(errorMessage(err, "Não foi possível alterar a palavra-passe."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel title="A tua conta" description={`Sessão iniciada como ${user?.email} · ${user?.role === "owner" ? "Fundadora" : "Administrador"}.`}>
      <form onSubmit={submit} className="max-w-md space-y-5" data-testid="change-password-form">
        <Field label="Palavra-passe atual" id="pw-current">
          <input id="pw-current" type="password" autoComplete="current-password" required value={form.current} onChange={set("current")} className="input-eden" data-testid="input-pw-current" />
        </Field>
        <Field label="Nova palavra-passe" id="pw-next" hint="Mínimo 10 caracteres, com letras e números.">
          <input id="pw-next" type="password" autoComplete="new-password" required minLength={10} value={form.next} onChange={set("next")} className="input-eden" data-testid="input-pw-next" />
        </Field>
        <Field label="Confirmar nova palavra-passe" id="pw-confirm">
          <input id="pw-confirm" type="password" autoComplete="new-password" required minLength={10} value={form.confirm} onChange={set("confirm")} className="input-eden" data-testid="input-pw-confirm" />
        </Field>
        <button type="submit" disabled={busy} className="btn-primary h-10" data-testid="change-password-submit">{busy ? "A alterar…" : "Alterar palavra-passe"}</button>
        <p className="text-xs text-eden-muted" data-testid="password-changed-at">
          {changedAt ? `Última alteração: ${formatDate(changedAt)}` : "A palavra-passe ainda é a inicial definida na configuração."}
        </p>
      </form>
    </Panel>
  );
}
